// extracted by mini-css-extract-plugin
export const sectionContactHero = "contactHero-module--sectionContactHero--XQhRu";
export const bgCircle = "contactHero-module--bgCircle--2UsXz";
export const sectionContainer = "contactHero-module--sectionContainer--3UjoQ";
export const contentWrap = "contactHero-module--contentWrap--moNBu";